"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageButton2 = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const utils_1 = require("../../utils");
function ImageButton2({ gameplayStyle, src, ...rest }) {
    return (react_1.default.createElement(material_1.ThemeProvider, { theme: (0, utils_1.getTheme)(gameplayStyle) },
        react_1.default.createElement(material_1.Button, { size: "large", color: "primary", sx: {
                padding: 0,
                borderRadius: '12px',
                overflow: 'clip',
            }, ...rest },
            react_1.default.createElement("img", { src: src, className: "object-cover" }))));
}
exports.ImageButton2 = ImageButton2;
